import { ArrayNotEmpty, Validate } from "class-validator";
import { CustomIdDTO } from "../common/id-validator.dto";

export class AssignBoxInterfaceDTO {

    @ArrayNotEmpty()
    @Validate(CustomIdDTO, { each: true })
    boxInterfaces : number[];
    
}

